// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__gPlRv","question":"Question_question__3mHwR","description":"Question_description__141-K"};